/**
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import { useTheme } from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'

/**
 * Hook to check if the browser is in mobile or desktop view.
 * @returns {boolean} isMobile - Boolean indicating current mobile state.
 * @returns {boolean} isDesktop - Boolean indicating current desktop state.
 */
function useBreakpoints() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isXs = useMediaQuery(theme.breakpoints.only('xs'))

  return {
    isXs,
    isMobile,
    isDesktop: !isMobile,
  }
}

export default useBreakpoints
